import { cva, VariantProps } from "class-variance-authority";
import React, { ReactNode } from "react";

import { cn } from "../../../../../libs/helpers/src";
import CustomTooltip from "./CustomTooltip";
import { Dot } from "./Dot";

const dotBadgeVariants = cva(
  "flex h-fit w-fit flex-row items-center rounded-full",
  {
    variants: {
      size: {
        default: "gap-2 px-2 py-0.5",
        small: "gap-2 px-4 py-1 text-sm font-semibold",
      },
      intent: {
        lightblue: "bg-lightblue-100 dark:bg-lightblue-900",
        warning: "bg-warning-100 dark:bg-warning-900",
        gray: "bg-gray-100 dark:bg-gray-700",
        error: "bg-error-50 dark:bg-error-900",
        success: "bg-success-50 dark:bg-success-900",
        secondary: "bg-secondary-25 dark:bg-secondary-800",
      },
    },
    defaultVariants: {
      intent: "gray",
      size: "default",
    },
  },
);
export type DotBadgeProps = {
  tooltip?: string;
  classNameOverride?: string;
  children: ReactNode;
} & VariantProps<typeof dotBadgeVariants>;

export const DotBadge: React.FC<DotBadgeProps> = ({
  intent,
  size,
  classNameOverride,
  children,
  tooltip,
}) => {
  const result = (
    <div className={cn(dotBadgeVariants({ intent, size }), classNameOverride)}>
      <Dot intent={intent} />
      {typeof children === "string" && (
        <div className="dark:text-gray-0 text-sm font-semibold text-gray-950">{children}</div>
      )}
      {typeof children !== "string" && children}
    </div>
  );
  if (tooltip) {
    return <CustomTooltip message={tooltip}>{result}</CustomTooltip>;
  }
  return result;
};
